/* eslint-disable complexity */
import { Grid } from '@elliemae/ds-grid';
import { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../constants/index.js';
import { ControlledDateTimePickerContext } from '../ControlledDateTimePickerCTX.js';
import { ClearButton } from './ClearButton/ClearButton.js';
import { DateInputs } from './DateInputs/DateInputs.js';
import { PickersIcons } from './Pickers/PickersIcons.js';
import { StyledInputsWrapperGrid } from './Styleds.js';
import { TimeInputs } from './TimeInputs/TimeInputs.js';

export const ControlledDateTimePickerContent = (): JSX.Element => {
  const {
    props: { hasError, disabled, readOnly, applyAriaDisabled },
    getProps,
    hideDate,
    hideTime,
    withAnyPicker,
    withAnyRightController,
    shouldPreserveClearableSpace,
    isControllerOnly,
    globalAttrs,
    xstyledAttrs,
    onGlobalKeyDown,
    handleComponentBlurs,
  } = useContext(ControlledDateTimePickerContext);

  const styledsAttrs = {
    justPicker: hideDate && hideTime,
    withAnyPicker,
    hasError,
    isControllerOnly,
  };

  const mainCols = [];
  if (!hideDate) mainCols.push('auto');
  if (!hideTime) mainCols.push('auto');
  if (withAnyRightController) mainCols.push('auto');

  const rightControlCols = [];
  if (shouldPreserveClearableSpace) rightControlCols.push('28px');
  if (withAnyPicker) rightControlCols.push('auto');

  const onlyPicker = hideDate && hideTime;

  const { tabIndex, autoFocus, ...globalAttrsWithoutFocus } = globalAttrs;

  return (
    <>
      {/* The <div> element is catching the component-wise global hotkeys, there is no valid aria role for this */}
      {/* eslint-disable-next-line max-len */}
      {/* https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md#case-the-event-handler-is-only-being-used-to-capture-bubbled-events */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <StyledInputsWrapperGrid
        cols={mainCols}
        gutter="xxs"
        pr={!withAnyRightController ? '2px' : '0px'}
        onKeyDown={onGlobalKeyDown}
        disabled={disabled}
        onBlur={handleComponentBlurs}
        data-testid={ControlledDateTimePickerDatatestid.CONTAINER}
        getOwnerProps={getProps}
        onlyPicker={onlyPicker}
        $readOnlyStyles={readOnly || applyAriaDisabled}
        {...styledsAttrs}
        {...globalAttrsWithoutFocus}
        {...xstyledAttrs}
      >
        {hideDate ? null : <DateInputs />}
        {hideTime ? null : <TimeInputs />}
        {withAnyRightController ? (
          <Grid cols={rightControlCols}>
            {shouldPreserveClearableSpace ? <ClearButton /> : null}
            {withAnyPicker ? <PickersIcons /> : null}
          </Grid>
        ) : null}
      </StyledInputsWrapperGrid>
    </>
  );
};
